import { checkIfIsNumber } from './number'
import { formatNumber } from './string'

const applyCPFMask = (cpf: string) => {
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

  return cpf
}

const applyCNPJMask = (cnpj: string) => {
  cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2')
  cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2')
  cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2')

  return cnpj
}

const applyCPFCNPJMask = (text: string) => {
  const value = text.replace(/\D/g, '')
  const isCPF = value.length <= 11

  return isCPF ? applyCPFMask(value) : applyCNPJMask(value)
}

const applyIntegerPositiveNumberMask = (value: string) => {
  let newValue = value
  if (!/^(?:^$|[1-9][0-9]*|0)$/.test(value) && value !== '') {
    newValue = '0'
  }
  return newValue
}

const applyBarBeforeLastNumberMask = (value: string) => {
  const newValue = value.substring(value.length - 1)
  return `${value.substring(0, value.length - 1)}/${newValue}`
}

const applyBarBeforeCDSGrad = (value: string) => {
  const parsList = value.replace(/((\d{2})(\d))/g, '$2/$3')
  return parsList
}

const applyIntegerOrFloatPositiveNumberMask = (value: string) => {
  let newValue = value
  if (!/^(?!0\d)\d*([,]\d{1,2})?$/.test(value) && value !== '') {
    newValue =
      /^(?!0\d)\d*([,])?$/.test(value) && value.endsWith(',') && value.length > 1
        ? value.padEnd(value.length + 1, '0')
        : '0'
  }
  return newValue
}

const applyNumberAboveZeroMask = (value: string) => {
  let newValue: string | number = parseInt(value.replace(/^[a-z0]$/, ''))
  if (!checkIfIsNumber(value)) {
    newValue = '0'
  }
  return applyIntegerPositiveNumberMask(newValue.toString())
}

const removeLeadingZerosMask = (value: string) =>
  value.charAt(1) === ','
    ? value
    : value.length > 1 && value.charAt(1) !== ','
    ? value.replace(/\b(?:0*(0,\d+)|0+)/g, '$1')
    : '0'

const leadingZerosMask = (value: string): string =>
  !/^[0]\d/.test(value) ? formatNumber(value) : formatNumber(value.replace(/^./, ''))

const verifyThreeDecimalNumbers = (value: string): string =>
  !/[,]\d{3}/.test(value) ? formatNumber(value) : formatNumber(value.replace(/\d$/, ''))

const percentualValueMask = (value: string) => {
  let newValue = leadingZerosMask(value)
  newValue = verifyThreeDecimalNumbers(newValue)
  return newValue
}

const decimalMask = (value: string | number) => {
  let newValue = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    currency: 'BRL'
  }).format(Number(value))
  if (!checkIfIsNumber(value)) {
    newValue = '0'
  }
  return newValue
}

export {
  applyCPFCNPJMask,
  applyCPFMask,
  applyCNPJMask,
  applyIntegerPositiveNumberMask,
  applyBarBeforeLastNumberMask,
  applyBarBeforeCDSGrad,
  applyIntegerOrFloatPositiveNumberMask,
  applyNumberAboveZeroMask,
  removeLeadingZerosMask,
  percentualValueMask,
  decimalMask
}
